import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FreeLayout } from 'Layouts';
import { registerSecondScreen } from 'State/SecondScreen/SecondScreenActions';
import './Confirmation.css';

const getScreenName = (isChangePlan, screens) => {
  const { confirmationScreen, upgradeConfirmationScreen = '' } = screens;
  return isChangePlan ? upgradeConfirmationScreen : confirmationScreen;
};

export const Confirmation = () => {
  const dispatch = useDispatch();
  const { screens } = useSelector((s) => s.appConfig);
  const { isChangePlan } = useSelector((s) => s.purchaseMode);
  const { isDeviceActivation } = useSelector((s) => s.secondScreen);
  const screenName = getScreenName(isChangePlan, screens);

  useEffect(() => {
    if (isDeviceActivation) {
      dispatch(registerSecondScreen());
    }
  }, [dispatch, isDeviceActivation]);

  return <FreeLayout className="congrats" screenName={screenName} />;
};
